import { StyledBody } from "./Body.style";

const Body = (props) => {
  return <StyledBody>{props.children}</StyledBody>;
};

export default Body;
